module.exports = __webpack_public_path__ + "img/iutmontreuil.f98bcc8e.png";